(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("te", [], factory);
	else if(typeof exports === 'object')
		exports["te"] = factory();
	else
		root["te"] = factory();
})(this, function() {
return 